<template>
  <!-- 查看附件 -->
  <div class="view-navbar">
    <ul class="clear-both">
      <li v-for="(item, index) in files">
        <el-tooltip class="item"
                    effect="dark"
                    :content="item.name"
                    placement="bottom">
          <img v-if="item.type === 'pic'"
               style="width: 100px; height: 100px;"
               :src="item.tmp_url"
               @click="onViewImage"
               :alt="item.name">
          <i v-else
             class="sj-icon-pdf"
             style="font-size:100px; margin-top: 50px"
             @click="onGetPdfFile(item, index)"></i>
        </el-tooltip>
      </li>
    </ul>
    <attached-file-preview :visible="attach_file_visible"
                           :file_title="file_title"
                           :url="attach_file_url"
                           @closeDialog="attach_file_visible = false">
    </attached-file-preview>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import Viewer from 'viewerjs'
import AttachedFilePreview from '@/views/payment-manager/components/AttachedFile'

export default {
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AttachedFilePreview,
  },
  data () {
    return {
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',
    }
  },
  methods: {
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      if (item.type === 'pdf') {
        request.common('getFinCenterFileUrl', item).then(({data}) => {
          window.open(data)
        })
      } else if (item.type === 'eml') {
        this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>


<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.view-navbar {
  right: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}

ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  /* height: 100px; */
  overflow: hidden;
  padding: 1px 0;
}

li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/AttachedFileList.vue